<!-- eslint-disable max-len -->
<template>
  <svg width="40px" height="40px" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path d="m181.55 224c-30.91 0-56 25.09-56 56s25.09 56 56 56c30.91 0 56-25.09 56-56s-25.086-56-56-56zm0 93.332c-20.59 0-37.332-16.727-37.332-37.332 0-20.59 16.742-37.332 37.332-37.332 20.59 0 37.332 16.742 37.332 37.332 0.003907 20.609-16.762 37.332-37.332 37.332z"/>
  <path d="m349.55 224c-30.91 0-56 25.09-56 56s25.09 56 56 56c30.91 0 56-25.09 56-56s-25.086-56-56-56zm0 93.332c-20.59 0-37.332-16.727-37.332-37.332 0-20.59 16.742-37.332 37.332-37.332 20.59 0 37.332 16.742 37.332 37.332 0.003907 20.609-16.762 37.332-37.332 37.332z"/>
  <path d="m517.55 224c-30.91 0-56 25.09-56 56s25.09 56 56 56c30.91 0 56-25.09 56-56s-25.086-56-56-56zm0 93.332c-20.59 0-37.332-16.727-37.332-37.332 0-20.59 16.742-37.332 37.332-37.332 20.59 0 37.332 16.742 37.332 37.332 0.003907 20.609-16.762 37.332-37.332 37.332z"/>
 </g>
</svg>
</template>
<script>
export default {
  name: 'threeDots',
};
</script>
